import { energyAnalysisApiSlice as api } from '../../../apiSlice';
export const addTagTypes = ['Energy Benchmarking'] as const;
const injectedRtkApi = api
  .enhanceEndpoints({
    addTagTypes,
  })
  .injectEndpoints({
    endpoints: (build) => ({
      getBuildingUseListBuildingUseListGet: build.query<
        GetBuildingUseListBuildingUseListGetApiResponse,
        GetBuildingUseListBuildingUseListGetApiArg
      >({
        query: () => ({ url: `/building_use_list` }),
        providesTags: ['Energy Benchmarking'],
      }),
      getHeatInstallationListHeatInstallationListGet: build.query<
        GetHeatInstallationListHeatInstallationListGetApiResponse,
        GetHeatInstallationListHeatInstallationListGetApiArg
      >({
        query: () => ({ url: `/heat_installation_list` }),
        providesTags: ['Energy Benchmarking'],
      }),
      extractBenchmarkDataBenchmarkAccountIdGet: build.query<
        ExtractBenchmarkDataBenchmarkAccountIdGetApiResponse,
        ExtractBenchmarkDataBenchmarkAccountIdGetApiArg
      >({
        query: (queryArg) => ({ url: `/benchmark/${queryArg.accountId}` }),
        providesTags: ['Energy Benchmarking'],
      }),
      calculateDetailedBenchmarkDataDetailedBenchmarkAccountIdMatrikelKeyGet:
        build.query<
          CalculateDetailedBenchmarkDataDetailedBenchmarkAccountIdMatrikelKeyGetApiResponse,
          CalculateDetailedBenchmarkDataDetailedBenchmarkAccountIdMatrikelKeyGetApiArg
        >({
          query: (queryArg) => ({
            url: `/detailed_benchmark/${queryArg.accountId}/${queryArg.matrikelKey}`,
          }),
          providesTags: ['Energy Benchmarking'],
        }),
      overwriteBenchmarkDataBenchmarkOverwriteAccountIdPost: build.mutation<
        OverwriteBenchmarkDataBenchmarkOverwriteAccountIdPostApiResponse,
        OverwriteBenchmarkDataBenchmarkOverwriteAccountIdPostApiArg
      >({
        query: (queryArg) => ({
          url: `/benchmark_overwrite/${queryArg.accountId}`,
          method: 'POST',
          body: queryArg.benchmarkOverwriteDataPoint,
        }),
        invalidatesTags: ['Energy Benchmarking'],
      }),
      getBenchmarkOverwriteDataAccountBenchmarkOverwriteAccountIdGet:
        build.query<
          GetBenchmarkOverwriteDataAccountBenchmarkOverwriteAccountIdGetApiResponse,
          GetBenchmarkOverwriteDataAccountBenchmarkOverwriteAccountIdGetApiArg
        >({
          query: (queryArg) => ({
            url: `/benchmark_overwrite/${queryArg.accountId}`,
          }),
          providesTags: ['Energy Benchmarking'],
        }),
      getBenchmarkOverwriteDataBenchmarkOverwriteAccountIdMatrikelKeyGet:
        build.query<
          GetBenchmarkOverwriteDataBenchmarkOverwriteAccountIdMatrikelKeyGetApiResponse,
          GetBenchmarkOverwriteDataBenchmarkOverwriteAccountIdMatrikelKeyGetApiArg
        >({
          query: (queryArg) => ({
            url: `/benchmark_overwrite/${queryArg.accountId}/${queryArg.matrikelKey}`,
          }),
          providesTags: ['Energy Benchmarking'],
        }),
      deleteBenchmarkOverwriteDataBenchmarkOverwriteAccountIdMatrikelKeyDelete:
        build.mutation<
          DeleteBenchmarkOverwriteDataBenchmarkOverwriteAccountIdMatrikelKeyDeleteApiResponse,
          DeleteBenchmarkOverwriteDataBenchmarkOverwriteAccountIdMatrikelKeyDeleteApiArg
        >({
          query: (queryArg) => ({
            url: `/benchmark_overwrite/${queryArg.accountId}/${queryArg.matrikelKey}`,
            method: 'DELETE',
          }),
          invalidatesTags: ['Energy Benchmarking'],
        }),
      updateBenchmarkOverwriteDataBenchmarkOverwriteAccountIdMatrikelKeyPatch:
        build.mutation<
          UpdateBenchmarkOverwriteDataBenchmarkOverwriteAccountIdMatrikelKeyPatchApiResponse,
          UpdateBenchmarkOverwriteDataBenchmarkOverwriteAccountIdMatrikelKeyPatchApiArg
        >({
          query: (queryArg) => ({
            url: `/benchmark_overwrite/${queryArg.accountId}/${queryArg.matrikelKey}`,
            method: 'PATCH',
            body: queryArg.benchmarkOverwritePatchInput,
          }),
          invalidatesTags: ['Energy Benchmarking'],
        }),
    }),
    overrideExisting: false,
  });
export { injectedRtkApi as energyAnalysisOpenApi };
export type GetBuildingUseListBuildingUseListGetApiResponse =
  /** status 200 Successful Response */ string[];
export type GetBuildingUseListBuildingUseListGetApiArg = void;
export type GetHeatInstallationListHeatInstallationListGetApiResponse =
  /** status 200 Successful Response */ string[];
export type GetHeatInstallationListHeatInstallationListGetApiArg = void;
export type ExtractBenchmarkDataBenchmarkAccountIdGetApiResponse =
  /** status 200 Successful Response */ BenchmarkDataOutput;
export type ExtractBenchmarkDataBenchmarkAccountIdGetApiArg = {
  /** The account id to get the energy benchmarking data for. */
  accountId: number;
};
export type CalculateDetailedBenchmarkDataDetailedBenchmarkAccountIdMatrikelKeyGetApiResponse =
  /** status 200 Successful Response */ DetailedBenchmarkDataOutput;
export type CalculateDetailedBenchmarkDataDetailedBenchmarkAccountIdMatrikelKeyGetApiArg =
  {
    /** The account id to get the energy consumption for. */
    accountId: number;
    /** The matrikel key to get the energy consumption for. */
    matrikelKey: string;
  };
export type OverwriteBenchmarkDataBenchmarkOverwriteAccountIdPostApiResponse =
  /** status 201 Successful Response */ BenchmarkOverwriteDataPoint;
export type OverwriteBenchmarkDataBenchmarkOverwriteAccountIdPostApiArg = {
  /** The account id to get the energy consumption for. */
  accountId: number;
  benchmarkOverwriteDataPoint: BenchmarkOverwriteDataPoint;
};
export type GetBenchmarkOverwriteDataAccountBenchmarkOverwriteAccountIdGetApiResponse =
  /** status 200 Successful Response */ BenchmarkOverwriteDataPoint[];
export type GetBenchmarkOverwriteDataAccountBenchmarkOverwriteAccountIdGetApiArg =
  {
    /** The account id to get the energy consumption for. */
    accountId: number;
  };
export type GetBenchmarkOverwriteDataBenchmarkOverwriteAccountIdMatrikelKeyGetApiResponse =
  /** status 200 Successful Response */ BenchmarkOverwriteDataPoint;
export type GetBenchmarkOverwriteDataBenchmarkOverwriteAccountIdMatrikelKeyGetApiArg =
  {
    /** The account id to get the energy consumption for. */
    accountId: number;
    /** The matrikel key to get the energy consumption for. */
    matrikelKey: string;
  };
export type DeleteBenchmarkOverwriteDataBenchmarkOverwriteAccountIdMatrikelKeyDeleteApiResponse =
  unknown;
export type DeleteBenchmarkOverwriteDataBenchmarkOverwriteAccountIdMatrikelKeyDeleteApiArg =
  {
    /** The account id to get the energy consumption for. */
    accountId: number;
    /** The matrikel key to get the energy consumption for. */
    matrikelKey: string;
  };
export type UpdateBenchmarkOverwriteDataBenchmarkOverwriteAccountIdMatrikelKeyPatchApiResponse =
  /** status 200 Successful Response */ BenchmarkOverwriteDataPoint;
export type UpdateBenchmarkOverwriteDataBenchmarkOverwriteAccountIdMatrikelKeyPatchApiArg =
  {
    /** The account id to get the energy consumption for. */
    accountId: number;
    /** The matrikel key to get the energy consumption for. */
    matrikelKey: string;
    benchmarkOverwritePatchInput: BenchmarkOverwritePatchInput;
  };
export type BenchmarkDataPoint = {
  /** The matrikel key. */
  MatrikelKey: string;
  /** The address of the matrikel. */
  Address: string;
  /** The BFE number. */
  BFENummer: number;
  /** The average building year. */
  AverageBuildingYear: number | null;
  /** The average kWh consumption sum. */
  AverageKWhConsumptionSum: number;
  /** The kWh per year per square meter. */
  kWhPrYPrM2: number;
  /** The benchmark position on the group cumulative distribution function. */
  BenchmarkCDF?: number | null;
  /** The number of data points in the benchmark group. */
  GroupCount?: number | null;
  /** The group mean. */
  GroupMean?: number | null;
  /** The group median. */
  GroupMedian?: number | null;
  /** The mean difference. */
  MeanDiff?: number | null;
  /** The median difference. */
  MedianDiff?: number | null;
  /** The sum building area. */
  SumBuildingArea: number;
  /** The total buildings. */
  TotalBuildings: number;
  /** The total metering points. */
  TotalMeteringPoints: number;
  /** The extracted building use. */
  ExtractedBuildingUse: string;
  /** The extracted heat installation. */
  ExtractedHeatInstallation: string;
  /** The building uses with area. */
  BuildingUsesWithArea: string;
  /** The original building uses with area. */
  OriginalBuildingUsesWithArea: string;
  /** The heat installations with area. */
  HeatInstallationsWithArea: string;
  /** If the benchmark data is an outlier. */
  OutlierFlag?: boolean;
  /** The reason for the outlier flag. */
  OutlierReason?: string | null;
  /** The EMO integration success. */
  EMOIntegrationSuccess?: boolean | null;
  /** The energy label classification. */
  EnergyLabelClassification?: string | null;
  /** The energy label count overview. */
  EnergyLabelCountOverview?: string | null;
  /** If some of the benchmark data is overwritten by the user. */
  OverwriteFlag?: boolean;
  /** If the benchmark data is verified by the user. */
  VerificationFlag?: boolean;
};
export type ApiWarning = {
  /** The warning message */
  message: string;
  /** The warning type */
  warning_type: string;
  /** The warning details */
  details?: object;
};
export type BenchmarkDataOutput = {
  /** The benchmark data. */
  BenchmarkData: BenchmarkDataPoint[];
  Warnings?: ApiWarning[];
};
export type ValidationError = {
  loc: (string | number)[];
  msg: string;
  type: string;
};
export type HttpValidationError = {
  detail?: ValidationError[];
};
export type PdfDataPoint = {
  /** The probability density of the data. (y-axis) */
  Density: number;
  /** The value of the data. (x-axis) */
  Value: number;
};
export type HistogramBin = {
  /** The start of the histogram bin. (inclusive) */
  BinStart: number;
  /** The end of the histogram bin. (exclusive) */
  BinEnd: number;
  /** The number of data points in the bin. */
  Count: number;
};
export type DetailedBenchmarkDataOutput = {
  /** The benchmark data as a probability density function. */
  BenchmarkPDF?: PdfDataPoint[];
  /** The benchmark data as a histogram with integer bin edges. */
  BenchmarkHistogram?: HistogramBin[];
  /** Anonymized kWhPrYPrM2 values used to compute the histogram. */
  BenchmarkHistogramValues?: number[];
  /** The benchmark data. */
  BenchmarkData: BenchmarkDataPoint;
  Warnings?: ApiWarning[];
};
export type BenchmarkOverwriteDataPoint = {
  /** The matrikel key. */
  MatrikelKey: string;
  /** The average building year. */
  AverageBuildingYear: number | null;
  /** The sum building area. */
  SumBuildingArea: number | null;
  /** The extracted building use. */
  ExtractedBuildingUse: string | null;
  /** The extracted heat installation. */
  ExtractedHeatInstallation: string | null;
  /** If the benchmark data is verified by the user and can be used for the benchmark. */
  VerificationFlag?: boolean;
};
export type BenchmarkOverwritePatchInput = {
  /** The average building year. */
  AverageBuildingYear: number | null;
  /** The sum building area. */
  SumBuildingArea: number | null;
  /** The extracted building use. */
  ExtractedBuildingUse: string | null;
  /** The extracted heat installation. */
  ExtractedHeatInstallation: string | null;
  /** If the benchmark data is verified by the user and can be used for the benchmark. */
  VerificationFlag?: boolean;
};
export const {
  useGetBuildingUseListBuildingUseListGetQuery,
  useGetHeatInstallationListHeatInstallationListGetQuery,
  useExtractBenchmarkDataBenchmarkAccountIdGetQuery,
  useCalculateDetailedBenchmarkDataDetailedBenchmarkAccountIdMatrikelKeyGetQuery,
  useOverwriteBenchmarkDataBenchmarkOverwriteAccountIdPostMutation,
  useGetBenchmarkOverwriteDataAccountBenchmarkOverwriteAccountIdGetQuery,
  useGetBenchmarkOverwriteDataBenchmarkOverwriteAccountIdMatrikelKeyGetQuery,
  useDeleteBenchmarkOverwriteDataBenchmarkOverwriteAccountIdMatrikelKeyDeleteMutation,
  useUpdateBenchmarkOverwriteDataBenchmarkOverwriteAccountIdMatrikelKeyPatchMutation,
} = injectedRtkApi;
